import { z } from 'zod';

export const weeklyStatusTransitionSchema = z.object({
  from: z.string(),
  to: z.string(),
  count: z.number(),
});

export const weeklyStatusCountsSchema = z.object({
  green: z.number(),
  yellow: z.number(),
  red: z.number(),
  grey: z.number(),
});

export const weeklySummarySchema = z.object({
  projectWeeklySummaryId: z.number(),
  projectId: z.number(),
  weekStartDate: z.string(),
  weekEndDate: z.string(),
  previousWeekStartDate: z.string(),
  projectTimezone: z.string(),
  iconWeekTimestamp: z.string(),
  previousIconWeekTimestamp: z.string(),
  totalSensors: z.number(),
  eligibleRecipientCount: z.number(),
  currentCounts: weeklyStatusCountsSchema,
  previousCounts: weeklyStatusCountsSchema,
  activeGatewayCount: z.number(),
  totalGatewayCount: z.number(),
  newRedSensorLocalIds: z.array(z.string()),
  allRedSensorLocalIds: z.array(z.string()),
  statusTransitions: z.array(weeklyStatusTransitionSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const weeklySummariesResponseSchema = z.object({
  weeklySummaries: z.array(weeklySummarySchema),
});

export type WeeklySummary = z.infer<typeof weeklySummarySchema>;
export type WeeklyStatusCounts = z.infer<typeof weeklyStatusCountsSchema>;
export type WeeklyStatusTransition = z.infer<typeof weeklyStatusTransitionSchema>;
